import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: any) => {
  return {
    center: {
      textAlign: "center",
      position: "relative",
      zIndex: 3,
    },
    titleLanding: {
      fontFamily: theme?.custom?.fontFamily?.arialRoundedMTBold,
      position: "relative",
      display: "inline-block",
      fontSize: 70,
      margin: "17px auto",
      marginBottom: 80,
      textShadow: `0px 0px 10px ${theme?.custom?.colors?.titleShadow2}, 0px 0px 50px ${theme?.custom?.colors?.titleShadow2}, 0px 0px 10px ${theme?.custom?.colors?.titleShadow2}`,
      color: theme?.custom?.colors?.title,

      [theme.breakpoints.down("md")]: {
        fontSize: 40,
      },

      [theme.breakpoints.down("sm")]: {
        fontSize: 24,
        marginBottom: 50,
      },

      "&:before": {
        backgroundImage: "url('/images/titles/before_title2.png')",
        backgroundSize: "100% 100%",
        display: "inline-block",
        width: 100,
        height: 23,
        content:'""',
        position: "absolute",
        right: "100%",
        marginRight: 58,
        top: "50%",
        transform: "translate(0, -35%)",

        [theme.breakpoints.down("sm")]: {
          marginRight: 20,
          width: 50,
          height: 11,
        },
      },

      "&:after": {
        backgroundImage: "url('/images/titles/after_title2.png')",
        backgroundSize: "100% 100%",
        display: "inline-block",
        width: 100,
        height: 23,
        content:'""',
        position: "absolute",
        left: "100%",
        marginLeft: 58,
        top: "50%",
        transform: "translate(0, -35%)",

        [theme.breakpoints.down("sm")]: {
          marginLeft: 20,
          width: 50,
          height: 11,
        },
      },
    },

    titleEffect: {

      "&:before": {
        display: "inline-block",
        width: 628,
        height: 153,
        content:'""',
        position: "absolute",
        right: -26,
        top: -13,
        transform: "translate(0, -35%)",

        [theme.breakpoints.down("sm")]: {
          right: "-66%",
        },
      },

      "&:after": {
        backgroundImage: "url('/images/titles/bot_title2.png')",
        backgroundSize: "100% 100%",
        display: "inline-block",
        width: 321,
        height: 37,
        marginTop: 35,
        content:'""',
        position: "absolute",
        left: "50%",
        top: "100%",
        transform: "translate(-50%, 0)",

        [theme.breakpoints.down("sm")]: {
          width: 120,
          height: 20,
          marginTop: 17,
        },
      },
    },

    bgWebm: {
      position: "absolute",
      maxWidth: "130%",
      zIndex: -1,
      right: "-15%",
      top: "-90%",
    },

    bgImg: {
      position: "absolute",
      maxWidth: "130%",
      right: "-15%",
      zIndex: -1,
      top: "-80%",
    },
  };
});

export default useStyles;
